<template>
  <div>
    <div class="container-1170">
      <div class="sidebar">
        <el-scrollbar :height="store.state.windowHeight - 130 + 'px'">
          <div class="sidebar-group" v-for="data in obj.datalist" :key="data.title">
            <p class="sidebar-group-title">{{data.title}}</p>
            <a class="link" v-for="item in data.subtitle" :key="item" @click="handleClick(item.url)" :class="obj.current===item.url?'active':''"><p class='link-text'>{{item.name}}</p></a>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, reactive } from "vue";
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const obj =  reactive({
      datalist: [{'title':'基础概念','subtitle':[{'url':'/doc/investor','name':'投资者和交易者'},{'url':'/doc/financial_markets','name':'金融市场'},{'url':'/doc/aaa','name':'aaa'},{'url':'/doc/bbb','name':'bbb'}]},
                 {'title':'技术分析','subtitle':[{'url':'/technology1','name':'技术1'},{'url':'/technology2','name':'技术2'},{'url':'/technology3','name':'技术3'},{'url':'/technology4','name':'技术4'}]},
                 {'title':'只做趋势','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'多强空弱','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'板块共振','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'周期共振','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'关键位置','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'回调开仓','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'设置保本','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'k线形态','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'时间窗口','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]},
                 {'title':'资金流向','subtitle':[{'url':'/trend1','name':'趋势1'},{'url':'/trend2','name':'趋势2'},{'url':'/trend3','name':'趋势3'},{'url':'/trend4','name':'趋势4'}]}],
      current: ''
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      if (route.path === '/'){
        obj.current = '/investor' // url中没有路径，则初始化investor页面
      } else {
        obj.current = route.path // url中指定路径，则跳转该页面
      }
      vueEvent.emit('event',obj.current) 
    })

    // 菜单点击事件
    const handleClick = (url) => {
      obj.current = url
      vueEvent.emit('event',url) 
    }

    return {
      obj,
      store,
      handleClick
    }
  }
}
</script>
<style lang="scss" scoped>
.sidebar {
  position: fixed;
  top: 0;
  z-index: 100;
  width: 250px;
  height: 90%;
  background-color: white;
  overflow-y: auto;
  margin: 66px 0px;
  border-right: solid 1px #E4E7ED
}

.link {
  display: block;
  padding: .625rem 2rem .625rem 1.5rem;
  line-height: 1.5;
  font-size: .9rem;
  margin: 0 18px;
  border-radius: 8px;
  cursor: pointer;
}

.link-text {
  line-height: 20px;
  font-size: 13px;
  font-weight: 500;
}

.link-text:hover {
  color: #53a8ff;
}

.active {
  color: #53a8ff;
  background-color: #d9ecff
}

.sidebar-group {
  padding: 20px 20px;
}

.sidebar-group-title {
  padding: .35rem 1.5rem .35rem 1.25rem;
  font-size: 1rem;
  font-weight: 700;
}
</style>
